

import Noticias from "views/Noticias/Noticias";
import MainAcademicosProf from "views/ProfAcademicos/MainAcademicosProf";
import MainMisAulas from "views/ProfAulas/MainMisAulas";
import Perfil from "views/Perfil/Perfil";

const Profesor = [
  {
    path: "/noticias",
    name: "Noticias",
    icon: "pe-7s-news-paper",
    component: Noticias,
    color:"#424242"
  },
  /* {
    path: "/icons",
    name: "Mis Artículos",
    icon: "pe-7s-share",
    component: Noticias,
    color:"#424242"
  }, */
  {
    path: "/prof_aulas",
    name: "Mis Aulas",
    icon: "pe-7s-culture",
    component: MainMisAulas,
    color:"#424242"
  },
  {
    path: "/prof_academicos",
    name: "Académicos",
    icon: "pe-7s-study",
    component: MainAcademicosProf,
    color:"#424242"
  },
/*   {
    path: "/table",
    name: "Horarios",
    icon: "pe-7s-date",
    component: Noticias,
    color:"#424242"
  }, */
  {
    path: "/perfil",
    name: "Perfil",
    icon: "pe-7s-search",
    component: Perfil,
    color:"#424242"
  },
  {
    path: "/Home",
    name: "Inicio",
    icon: "pe-7s-home",
    component: Noticias,
    color:"#424242"
  }
];

export default Profesor;




// WEBPACK FOOTER //
// ./src/routes/Profesor.jsx